<script>
import valid from '@/valid'

export default {
  computed: {
    prod () {
      return process.env.NODE_ENV === 'production'
    }
  },
  watch: {
    /**
     * router
     */
    '$route' (val) {
      this.$i18n.locale = val.params.lang
    }
  },
  methods: {
    /**
     * バリデーション
     */
    v (name, types) {
      let funcs = []

      for (let i = 0; i < types.length; i++) {
        const type = types[i]
        if (types.indexOf(type) < 0) {
          this.utils.debug.error(`${type} is not found`)
        }
        funcs.push(val => valid[type](val, this.$t(`valid.${type}`, [name])))
      }

      return funcs
    }
  }
}
</script>
